import {
  Button,
  createSelectField,
  StandardDialog,
} from '@roc/ui';
import { useDocumentStore } from '@roc/feature-documents';
import { Document } from '@roc/feature-types';
import { useEffect, useState } from 'react';
import { Divider, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { Alert } from '@material-ui/lab';

type Props = {
  document: Document;
};

const idTypeOptions = [
  { label: 'Please Select', value: '' },
  {
    label: "US Driver's License / Government ID",
    value: "US Driver's License / Government ID",
  },
  { label: 'US Passport', value: 'US Passport' },
  { label: 'Green Card', value: 'Green Card' },
  { label: 'Visa', value: 'Visa' },
  { label: 'Non-US Passport', value: 'Non-US Passport' },
];

export const PersonalIdentificationForm = observer((props: Props) => {
  const [idType, setIdType] = useState('');
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { personalIdentificationFormStore } = documentFormStore;
  const store = personalIdentificationFormStore;
  const document = props.document;

  const canDownload = !!document.dropboxPath;

  const message = !canDownload
    ? `${document.taskName} has not been uploaded`
    : `${document.taskName} was last uploaded at ${document.lastUpdateDate}`;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {createSelectField({
          store,
          fieldName: 'idType',
          testId: 'idType',
          label: 'ID Type',
          options: idTypeOptions,
        })}
      </Grid>
      <Grid item xs={12}>
        <Alert severity="info">{message}</Alert>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          color="primary"
          disabled={!canDownload}
          onClick={() => documentStore.downloadDocument(document)}
          testId="download"
        >
          Download
        </Button>
      </Grid>
    </Grid>
  );
});
